import { useCardBack } from '../../../cardBacks.js';
import { useI18n } from '../../../i18n.js';
import { DaaluuTile } from './DaaluuTile.js';
import './daaluu.css';

/** Personal appearance preference, independent of card cosmetics and room rules. */
export function DaaluuColorPicker() {
  const { daaluuColor, setDaaluuColor } = useCardBack();
  const { lang } = useI18n();
  const mn = lang === 'mn';
  return <div className="daaluu-color-picker" role="group" aria-label={mn ? 'Даалууны өнгө' : 'Daaluu tile color'}>
    {(['white', 'black'] as const).map(color => {
      const label = mn ? `${color === 'white' ? 'Цагаан' : 'Хар'} даалуу` : `${color === 'white' ? 'White' : 'Black'} Daaluu tiles`;
      return <button key={color} type="button" className="daaluu-color-choice" aria-label={label}
        title={label} aria-pressed={daaluuColor === color} onClick={() => setDaaluuColor(color)}>
        <span data-daaluu-color={color} aria-hidden="true"><DaaluuTile tile={{ id: `finish-${color}`, kindId: 'daaluu' }} /></span>
        {daaluuColor === color && <svg className="daaluu-color-check" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" /><path d="m4 8 3 3 5-6" /></svg>}
      </button>;
    })}
  </div>;
}
